export default __webpack_public_path__ + "media/images/titre-ongletcentre-a8d7c1f0e3e9062cabe487fa903013ec.png";